import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css'; // Optional: your global styles
import App from './App'; // This will include your `NewsletterHome` component
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
